import React, { useEffect, useRef } from 'react';
import styles from './Contact.module.css';
import YouMayAlsoLike from '../components/YouMayAlsoLike';

const Contact = ({ onNavigate }) => {
  const pageRef = useRef(null);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  const contactInfo = {
    phone: '+447751980456',
    email: 'thequeenshotelharlech@gmail.com',
    address: {
      name: 'The Queens Hotel Harlech',
      street: 'Castell Morfa',
      city: 'Harlech',
      postcode: 'LL46 2UF'
    },
    whatsapp: 'https://wa.me/447751980456',
    facebook: 'https://www.facebook.com/thequeensbarharlech/?locale=en_GB',
    booking: 'https://www.booking.com/hotel/gb/the-queens-harlech.en-gb.html',
    googleMaps: 'https://maps.google.com/?q=52.861536582270524,-4.110125222048405'
  };

  return (
    <div ref={pageRef} className={styles['contact-page']}>
      <div className={styles.container}>
        <h1 className={styles['page-title']}>Contact Us</h1>
        
        {/* Introduction Section */}
        <div className={styles['intro-section']}>
          <p>
            We'd love to hear from you! Whether you're planning a stay, have a question about our facilities, 
            or want to make a reservation, there are several ways to get in touch with us.
          </p>
        </div>

        {/* Contact Methods Grid */}
        <div className={styles['contact-grid']}>
          
          {/* Phone Section */}
          <div className={styles['contact-card']}>
            <h2 className={styles['contact-title']}>Call Us</h2>
            <div className={styles['contact-content']}>
              <p className={styles['contact-description']}>
                Speak directly with our friendly team for immediate assistance with bookings, 
                enquiries, or any questions about your stay.
              </p>
              <a 
                href={`tel:${contactInfo.phone}`}
                className={styles['contact-button']}
              >
                Call Us
              </a>
            </div>
          </div>

          {/* WhatsApp Section */}
          <div className={styles['contact-card']}>
            <h2 className={styles['contact-title']}>Message Us</h2>
            <div className={styles['contact-content']}>
              <p className={styles['contact-description']}>
                Send us a WhatsApp message for quick responses to your questions. 
                Perfect for photos, booking requests, or general enquiries.
              </p>
              <a 
                href={contactInfo.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className={styles['contact-button']}
              >
                Message Us
              </a>
            </div>
          </div>

          {/* Email Section */}
          <div className={styles['contact-card']}>
            <h2 className={styles['contact-title']}>Email Us</h2>
            <div className={styles['contact-content']}>
              <p className={styles['contact-description']}>
                Drop us an email for detailed enquiries, special requests, 
                or if you prefer written communication.
              </p>
              <a 
                href={`mailto:${contactInfo.email}`}
                className={styles['contact-button']}
              >
                Email Us
              </a>
            </div>
          </div>

          {/* Location Section */}
          <div className={styles['contact-card']}>
            <h2 className={styles['contact-title']}>Find Us</h2>
            <div className={styles['contact-content']}>
              <p className={styles['contact-description']}>
                Located in lower Harlech, just minutes from the castle 
                and railway station. Parking is available on-site.
              </p>
              <div className={styles['address-details']}>
                <p>{contactInfo.address.name}</p>
                <p>{contactInfo.address.street}</p>
                <p>{contactInfo.address.city}</p>
                <p>{contactInfo.address.postcode}</p>
              </div>
            </div>
          </div>

          {/* Social Media Section */}
          <div className={styles['contact-card']}>
            <h2 className={styles['contact-title']}>Follow Us</h2>
            <div className={styles['contact-content']}>
              <p className={styles['contact-description']}>
                Stay updated with our latest news, events, and special offers 
                by following us on social media.
              </p>
              <a 
                href={contactInfo.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className={styles['contact-button']}
              >
                Facebook Page
              </a>
            </div>
          </div>

          {/* Booking Section */}
          <div className={styles['contact-card']}>
            <h2 className={styles['contact-title']}>Stay With Us</h2>
            <div className={styles['contact-content']}>
              <p className={styles['contact-description']}>
                Ready to book your stay? Check availability and make your reservation 
                through our booking partner.
              </p>
              <a 
                href={contactInfo.booking}
                target="_blank"
                rel="noopener noreferrer"
                className={styles['contact-button']}
              >
                Book on Booking.com
              </a>
            </div>
          </div>
        </div>

        {/* Google Maps Embed Section */}
        <div className={styles['map-section']}>
          <h2 className={styles['section-title']}>Our Location</h2>
          <div className={styles['map-container']}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2408.8!2d-4.110125222048405!3d52.861536582270524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTLCsDUxJzQxLjUiTiA0wrAwNiczNi41Ilc!5e0!3m2!1sen!2suk!4v1000000000000!5m2!1sen!2suk"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="The Queens Hotel Harlech Location"
              className={styles['google-map']}
            ></iframe>
          </div>
          <div className={styles['map-info']}>
            <p>
              We're conveniently located just 80 meters from Harlech railway station and 
              a short walk from the magnificent Harlech Castle. Parking is available on-site.
            </p>
          </div>
        </div>
      </div>
      <YouMayAlsoLike currentPage="contact" onNavigate={onNavigate} />
    </div>
  );
};

export default Contact;